import { lazy } from 'react';
import type { RouteMap } from '@/scripts/router/types';
import { mergeRouteMap } from '@/scripts/router';
import App from '@/App';
import Main from '@/pages/main';
import ChatList from '@/pages/main/messages/ChatList'; // don't use lazy here
import MessagePage from '@/pages/main/messages'; // don't use lazy here
import SessionContents from '@/pages/main/messages/ChatContent'; // don't use lazy here
import LoginLoading from '@/pages/login/loading';
import ErrorPage from '@/pages/error';
import Paths from './paths';
import { routeMap } from './routeMap';

const KickOut = lazy(() => import('@/pages/kick-out'));
const ContactsPage = lazy(() => import('@/pages/main/contacts'));
const ContactsChatGroupPage = lazy(
  () => import('@/pages/main/contacts/ContactsContent/ChatGroup')
);
const SettingsPage = lazy(() => import('@/pages/main/settings'));
// const FeedsPage = lazy(() => import('@/pages/main/feeds'));
// const ShortsPage = lazy(() => import('@/pages/main/shorts'));
// const WalletPage = lazy(() => import('@/pages/main/wallet'));
const SettingsNotificationsPage = lazy(() => import('@/pages/main/settings/notifications'));
const SettingsGeneralPage = lazy(() => import('@/pages/main/settings/general'));
const SettingsSecurityPage = lazy(() => import('@/pages/main/settings/security'));
const SettingsPrivacyPage = lazy(() => import('@/pages/main/settings/privacy'));
const SyncBackupPage = lazy(() => import('@/pages/main/settings/syncBackup'));
const SettingsDevicesPage = lazy(() => import('@/pages/main/settings/devices'));
const SettingsAboutPage = lazy(() => import('@/pages/main/settings/about'));
const SettingsLanguagePage = lazy(() => import('@/pages/main/settings/language'));
const ShortsMain = lazy(() => import('@/pages/main/shorts'));
const DocsMain = lazy(() => import('@/pages/main/docs'));

// Configure the element here separately to avoid load order problems when reading menu data
export const routeMapRuntime: RouteMap = mergeRouteMap(
  {
    [Paths.BASE]: {
      element: <App></App>,
      errorElement: <ErrorPage />,
    },
    [Paths.ERROR]: {
      element: <ErrorPage />,
    },
    [Paths.MAIN]: {
      element: <Main></Main>,
    },
    [Paths.LOGIN]: {
      element: <LoginLoading></LoginLoading>,
    },
    [Paths.AUTH_CALLBACK]: {},
    [Paths.KICK_OUT]: {
      element: <KickOut></KickOut>,
    },
    [Paths.CALLS]: {
      element: <div>calls</div>,
    },
    [Paths.MESSAGES]: {
      element: <MessagePage />,
    },
    [Paths.MESSAGES_CHATS]: {
      element: <SessionContents />,
      handle: {
        msgSidebar: <ChatList />,
      },
    },
    [Paths.CONTACTS]: {
      element: <ContactsPage />,
    },
    [Paths.CONTACTS_GROUP_CHAT]: {
      element: <ContactsChatGroupPage />,
    },
    [Paths.FEEDS]: {
      element: <div>feeds</div>,
    },
    [Paths.SHORTS]: {
      element: <ShortsMain />,
    },
    [Paths.WALLET]: {
      element: <div>wallet</div>,
    },
    [Paths.DOCS]: {
      element: <DocsMain />,
    },
    [Paths.SETTINGS]: {
      element: <SettingsPage />,
    },
    [Paths.SETTINGS_NOTIFICATIONS]: {
      element: <SettingsNotificationsPage />,
    },
    [Paths.SETTINGS_GENERAL]: {
      element: <SettingsGeneralPage />,
    },
    [Paths.SETTINGS_SECURITY]: {
      element: <SettingsSecurityPage />,
    },
    [Paths.SETTINGS_PRIVACY]: {
      element: <SettingsPrivacyPage />,
    },
    [Paths.SETTINGS_SYNC_BACKUP]: {
      element: <SyncBackupPage />,
    },
    [Paths.SETTINGS_DEVICES]: {
      element: <SettingsDevicesPage />,
    },
    [Paths.SETTINGS_ABOUT]: {
      element: <SettingsAboutPage />,
    },
    [Paths.SETTINGS_LANGUAGE]: {
      element: <SettingsLanguagePage />,
    },
    [Paths.NOT_FOUND]: {
      element: <div>not found</div>,
    },
  },
  routeMap
);
